import { Zmanim, GeoLocation, HDate } from '@hebcal/core';

/**
 * Determine the halachic date by checking if current time is after sunset.
 * HDate has NO built-in sunset awareness — we must use Zmanim separately.
 *
 * @param {Date} now - current JS Date
 * @param {{ lat: number, lng: number, timezone: string }} location
 * @returns {{ hdate: HDate, isAfterSunset: boolean, sunset: Date|null }}
 */
export function getHalachicDate(now, location) {
  const gloc = new GeoLocation(
    'loc',
    location.lat,
    location.lng,
    0,
    location.timezone
  );
  const zmanim = new Zmanim(gloc, now, false);
  const sunset = zmanim.sunset();

  if (sunset && now >= sunset) {
    // After sunset — halachic date is tomorrow
    const tomorrow = new Date(now);
    tomorrow.setDate(tomorrow.getDate() + 1);
    return {
      hdate: new HDate(tomorrow),
      isAfterSunset: true,
      sunset,
    };
  }

  return {
    hdate: new HDate(now),
    isAfterSunset: false,
    sunset,
  };
}
